module.exports = __webpack_public_path__ + "img/trade_black.1279b43f.png";